__turbopack_context__.v({
  "contact": "TeamIntroduction-module-scss-module__m8sw2q__contact",
  "container": "TeamIntroduction-module-scss-module__m8sw2q__container",
  "content": "TeamIntroduction-module-scss-module__m8sw2q__content",
  "image": "TeamIntroduction-module-scss-module__m8sw2q__image",
  "innerImage": "TeamIntroduction-module-scss-module__m8sw2q__innerImage",
  "mobileTitle": "TeamIntroduction-module-scss-module__m8sw2q__mobileTitle",
  "text": "TeamIntroduction-module-scss-module__m8sw2q__text",
});
